import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { AiOutlineClose, AiOutlineLoading } from 'react-icons/ai';
import { Button } from 'reakit/Button';
import { Tooltip, TooltipArrow, TooltipReference, useTooltipState } from 'reakit/Tooltip';
import styles from './ActionButton.module.less';
const ActionButton = forwardRef((props, ref) => {
    const { children, disabled, focusable = true, icon: Icon = AiOutlineClose, id, loading = false, onClick, size = '', style, className, text, tooltipPlacement = 'bottom', type = 'button' } = props;
    const tooltipID = `${id}-tooltip`;
    const tooltip = useTooltipState({
        baseId: tooltipID,
        placement: tooltipPlacement
    });
    const ariaProps = {};
    for (const [propKey, propValue] of Object.entries(props)) {
        if (propKey.startsWith('aria')) {
            if (typeof propValue === 'string') {
                ariaProps[propKey] = propValue;
            }
            else if (typeof propValue === 'boolean') {
                ariaProps[propKey] = String(propValue);
            }
        }
    }
    const FinalIcon = loading ? AiOutlineLoading : Icon;
    const buttonContent = children ? (children) : (_jsx(FinalIcon, { role: "presentation", className: loading ? styles['spin'] : undefined }));
    if (disabled) {
        return (_jsxs(_Fragment, { children: [_jsx(TooltipReference, { ...tooltip, ...ariaProps, "aria-labelledby": tooltipID, as: "span", className: styles['action-button-wrapper'], children: _jsx(Button, { className: [
                            styles['action-button'],
                            styles[size],
                            className
                        ]
                            .filter(Boolean)
                            .join(' '), disabled: true, focusable: false, id: id, ref: ref, style: style, type: type, children: buttonContent }) }), _jsxs(Tooltip, { ...tooltip, className: styles['hvui-tooltip'], children: [_jsx(TooltipArrow, { ...tooltip }), text] })] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(TooltipReference, { ...tooltip, ...ariaProps, "aria-labelledby": tooltipID, as: Button, className: [
                    styles['action-button'],
                    styles[size],
                    className
                ]
                    .filter(Boolean)
                    .join(' '), disabled: disabled, focusable: focusable, id: id, onClick: onClick, ref: ref, style: style, type: type, children: buttonContent }), _jsxs(Tooltip, { ...tooltip, className: styles['hvui-tooltip'], children: [_jsx(TooltipArrow, { ...tooltip }), text] })] }));
});
export default ActionButton;
